import React, { useState } from 'react';
import { CONSTANTS } from '../../constants';

const RockPaperScissors = ({ onClose }) => {
  const [aiChoiceUrl, setAiChoiceUrl] = useState(CONSTANTS.RPS.QUESTION_MARK_IMAGE_URL);
  const [score, setScore] = useState({ ai: 0, user: 0 });
  const [lastResult, setLastResult] = useState('');

  const ROCK_VALUE = 0;
  const PAPER_VALUE = 1;
  const SCISSORS_VALUE = 2;
  const WIN = 0;
  const LOSS = 1;

  const rps = [
    { value: ROCK_VALUE, imageUrl: CONSTANTS.RPS.ROCK_IMAGE_URL, name: 'Rock' },
    { value: PAPER_VALUE, imageUrl: CONSTANTS.RPS.PAPER_IMAGE_URL, name: 'Paper' },
    { value: SCISSORS_VALUE, imageUrl: CONSTANTS.RPS.SCISSORS_IMAGE_URL, name: 'Scissors' }
  ];

  const rpsImageMapping = {
    0: CONSTANTS.RPS.ROCK_IMAGE_URL,
    1: CONSTANTS.RPS.PAPER_IMAGE_URL,
    2: CONSTANTS.RPS.SCISSORS_IMAGE_URL
  };

  const aiMakeChoice = () => {
    return Math.floor((Math.random() * rps.length));
  };

  const makeChoice = (choice) => {
    const aiChoice = aiMakeChoice();
    let verdict = undefined;

    setAiChoiceUrl(rpsImageMapping[aiChoice]);

    if (aiChoice === choice) {
      setLastResult('It was a tie!');
      revertAiChoice();
      return;
    }

    switch (choice) {
      case ROCK_VALUE:
        if (aiChoice === PAPER_VALUE) {
          verdict = LOSS;
        } else if (aiChoice === SCISSORS_VALUE) {
          verdict = WIN;
        }
        break;
      case PAPER_VALUE:
        if (aiChoice === ROCK_VALUE) {
          verdict = WIN;
        } else if (aiChoice === SCISSORS_VALUE) {
          verdict = LOSS;
        }
        break;
      case SCISSORS_VALUE:
        if (aiChoice === PAPER_VALUE) {
          verdict = WIN;
        } else if (aiChoice === ROCK_VALUE) {
          verdict = LOSS;
        }
        break;
      default:
        setLastResult('Something went wrong. Please try playing again!');
        return;
    }

    if (verdict === WIN) {
      setLastResult('Congrats, you win this round!');
      setScore(prev => ({ ...prev, user: prev.user + 1 }));
    } else if (verdict === LOSS) {
      setLastResult('Sorry, the AI got the best of you!');
      setScore(prev => ({ ...prev, ai: prev.ai + 1 }));
    }

    revertAiChoice();
  };

  const revertAiChoice = () => {
    setTimeout(() => {
      setAiChoiceUrl(CONSTANTS.RPS.QUESTION_MARK_IMAGE_URL);
    }, 1000);
  };

  const resetGame = () => {
    setScore({ ai: 0, user: 0 });
    setLastResult('');
    setAiChoiceUrl(CONSTANTS.RPS.QUESTION_MARK_IMAGE_URL);
  };

  return (
    <div>
      <div className="text-center mb-4">
        <h4>Rock Paper Scissors</h4>
        <div className="row">
          <div className="col-md-6">
            <h6>Your Score: {score.user}</h6>
          </div>
          <div className="col-md-6">
            <h6>AI Score: {score.ai}</h6>
          </div>
        </div>
      </div>

      <div className="text-center mb-4">
        <div className="row">
          <div className="col-md-6">
            <h6>AI Choice:</h6>
            <img 
              src={aiChoiceUrl} 
              alt="AI Choice" 
              style={{ width: '100px', height: '100px' }}
              className="img-fluid"
            />
          </div>
          <div className="col-md-6">
            <h6>Make Your Choice:</h6>
            <div className="d-flex justify-content-center gap-3">
              {rps.map((option) => (
                <button
                  key={option.value}
                  className="btn btn-outline-primary"
                  onClick={() => makeChoice(option.value)}
                  style={{ padding: '10px' }}
                >
                  <img 
                    src={option.imageUrl} 
                    alt={option.name}
                    style={{ width: '50px', height: '50px' }}
                    className="img-fluid"
                  />
                  <div className="small">{option.name}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {lastResult && (
        <div className="alert alert-info text-center">
          {lastResult}
        </div>
      )}

      <div className="text-center">
        <button className="btn btn-secondary" onClick={resetGame}>
          Reset Game
        </button>
      </div>
    </div>
  );
};

export default RockPaperScissors;
